/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約共通情報
 */
export interface Szma301aResponseGasCtrSearchResultDtoCtrCommonMstInfo {
    /**
     * 契約番号：数字
     */
    ctrNo?: string;
    /**
     * 更新通番号：数字
     */
    updateSrno?: string;
    /**
     * サービス契約番号：数字
     */
    srvCtrNo?: string;
    /**
     * プロダクトコード：英数字
     */
    prdCode?: string;
    /**
     * サービス契約締結日付：日付(yyyyMMdd)
     */
    prdCtrDate?: string;
    /**
     * サービス契約解約日付：日付(yyyyMMdd)
     */
    prdBreakDate?: string;
    /**
     * 契約お客さま番号：数字
     */
    firstSrvctrNo?: string;
    /**
     * 契約状態区分：英数字<br>　コード変換マスターテーブル.画面項目ID「D000190」のユーザコードを設定
     */
    ctrStateDiv?: string;
    /**
     * 契約状態区分名称：全半角混在
     */
    ctrStateDivAname?: string;
    /**
     * 販売形態コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300020」のユーザコードを設定
     */
    salfrmCode?: string;
    /**
     * 販売形態コード名称：全半角混在
     */
    salfrmCodeAname?: string;
    /**
     * 中継店内部お客さま番号：数字
     */
    rlyisdVisitNo?: string;
    /**
     * 中継店担当者名：全角
     */
    rlystrFname?: string;
    /**
     * ポータルＩＤ：英数字
     */
    portalId?: string;
    /**
     * 認証コード：英数字
     */
    certCode?: string;
    /**
     * 支払設定仮パスワード：英数字
     */
    payTmprryPw?: string;
    /**
     * 取次店発行お客さま番号：英数字
     */
    agnissVisitNo?: string;
    /**
     * 請求月度区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C021080」のユーザコードを設定
     */
    claimMnttmDiv?: string;
    /**
     * 請求月度区分名称：全半角混在
     */
    claimMnttmDivAname?: string;
    /**
     * 契約有効期間開始日付：日付(yyyyMMdd)
     */
    ctrefctkiStrtdate?: string;
    /**
     * サービス契約情報メモテキスト：全角
     */
    srvctrInfoMemo?: string;
    /**
     * 契約修正日付：日付(yyyyMMdd)
     */
    ctrSyuseiDate?: string;
    /**
     * サービス契約解約理由コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C000860」のユーザコードを設定
     */
    srvctrBreakRsncod?: string;
    /**
     * サービス契約解約理由コード名称：全半角混在
     */
    srvctrBreakRsncodAname?: string;
    /**
     * 前払・後払区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C021420」のユーザコードを設定
     */
    autksnCtrfrmDiv?: string;
    /**
     * 前払・後払区分名称：全半角混在
     */
    autksnCtrfrmDivAname?: string;
    /**
     * 契約登録処理日付：日付(yyyyMMdd)
     */
    regTrnDate?: string;
    /**
     * 契約終了処理日付：日付(yyyyMMdd)
     */
    ctrcanTrnDate?: string;
    /**
     * 契約有効期間終了日付：日付(yyyyMMdd)
     */
    ctrEfctedDate?: string;
    /**
     * 請求単位：英数字<br>　コード変換マスターテーブル.画面項目ID「C010970」のユーザコードを設定
     */
    claimUnit?: string;
    /**
     * 請求単位名称：全半角混在
     */
    claimUnitAname?: string;
    /**
     * 支払指定月：英数字<br>　コード変換マスターテーブル.画面項目ID「C001370」のユーザコードを設定
     */
    rcvmnySiteiMonth?: string;
    /**
     * 支払指定月名称：全半角混在
     */
    rcvmnySiteiMonthAname?: string;
    /**
     * 契約番号枝番：数字
     */
    ctrnumBrcno?: string;
    /**
     * 契約更新区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C008790」のユーザコードを設定
     */
    ctrupdDiv?: string;
    /**
     * 契約更新区分名称：全半角混在
     */
    ctrupdDivAname?: string;
    /**
     * 契約開始日付：日付(yyyyMMdd)
     */
    ctrStrtdt?: string;
    /**
     * 契約終了日付：日付(yyyyMMdd)
     */
    ctrEnddt?: string;
    /**
     * プロダクト正式名：全角
     */
    prdAname?: string;
    /**
     * プロダクト略式名：全角
     */
    prdRyaku?: string;
    /**
     * プロダクト画面表示用略式名：全角
     */
    prdDispAname?: string;
    /**
     * 事業コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C011320」のユーザコードを設定
     */
    businsCode?: string;
    /**
     * 事業コード名称：全半角混在
     */
    businsCodeAname?: string;
    /**
     * プロダクト種別区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C011300」のユーザコードを設定
     */
    prdClsfyDiv?: string;
    /**
     * プロダクト種別区分名称：全半角混在
     */
    prdClsfyDivAname?: string;
    /**
     * サービス種別コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C008410」のユーザコードを設定
     */
    srvClsfyCode?: string;
    /**
     * サービス種別コード名称：全半角混在
     */
    srvClsfyCodeAname?: string;
    /**
     * 免税対象フラグ：英数字<br>　コード変換マスターテーブル.画面項目ID「C000350」のユーザコードを設定
     */
    exmptTargetFlg?: string;
    /**
     * 免税対象フラグ名称：全半角混在
     */
    exmptTargetFlgAname?: string;
}

